import React from "react";
import { Close } from "@mui/icons-material";
import customDate from "../../../../utils/customDate";
import customTime from "../../../../utils/customTime";
import RenderSeatMap from "../RenderSeatMap";

const Ancillaries = ({
  isBaggageModalOpen,
  setIsBaggageModalOpen,
  passengers,
  activePassengerTab,
  setActivePassengerTab,
  baggageDetails,
  selectedBaggage,
  setSelectedBaggage,
  formatCurrency,
  isMealModalOpen,
  setIsMealModalOpen,
  mealDetails,
  activeMealSegmentTab,
  setActiveMealSegmentTab,
  selectedSeats,
  setSelectedSeats,
  setActiveSeatTab,
  selectedMeals,
  setSelectedMeals,
  isSeatModalOpen,
  setIsSeatModalOpen,
  setAutoSelectedSeats,
  autoSelectedSeats,
  activeSeatTab,
  seatDetails,
}) => {
  const getGlobalSegmentStartIndex = (journeyIdx) => {
    let startIndex = 0;
    if (!baggageDetails) return 0;
    for (let i = 0; i < journeyIdx; i++) {
      startIndex += baggageDetails[i].flightSegments.length;
    }
    return startIndex;
  };

  return (
    <div>
      {isBaggageModalOpen && (
        <div className="flex fixed inset-0 z-50 justify-center items-center bg-black bg-opacity-50">
          <div className="bg-white rounded-2xl p-6 max-w-4xl w-full mx-4 text-black max-h-[90vh] overflow-y-auto">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-xl font-semibold">Select Baggage</h3>
              <button onClick={() => setIsBaggageModalOpen(false)}>
                <Close className="w-6 h-6" />
              </button>
            </div>

            {/* Passenger Tabs */}
            <div className="mb-6 border-b border-gray-200">
              <nav className="flex -mb-px space-x-8">
                {passengers?.map((passenger, passengerIdx) => {
                  return (
                    <button
                      key={passengerIdx}
                      className={`py-2 px-4 border-b-2 font-medium text-sm ${
                        activePassengerTab === passengerIdx
                          ? "border-main-900 text-main"
                          : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                      }`}
                      onClick={() => setActivePassengerTab(passengerIdx)}
                    >
                      Passenger {passengerIdx + 1}
                    </button>
                  );
                })}
              </nav>
            </div>

            {baggageDetails ? (
              baggageDetails.map((detail, detailIdx) => (
                <div
                  key={detailIdx}
                  className="p-4 mb-6 rounded-xl border border-gray-100 bg-gray-50/30"
                >
                  <h4 className="mb-4 font-semibold text-gray-800">
                    Journey:{" "}
                    {[
                      detail.flightSegments[0]?.segmentCode?.split("/")?.[0],
                      detail.flightSegments[
                        detail.flightSegments.length - 1
                      ]?.segmentCode?.split("/")?.[1],
                    ]
                      .filter(Boolean)
                      .join(" → ")}
                  </h4>
                  <div className="grid gap-2">
                    {detail.baggageOptions.map((option) => {
                      const globalStartIdx =
                        getGlobalSegmentStartIndex(detailIdx);
                      const isSelected =
                        selectedBaggage[activePassengerTab]?.[globalStartIdx]
                          ?.baggageCode === option.baggageCode;

                      return (
                        <button
                          key={option.baggageCode}
                          className={`p-3 border rounded-lg transition-all ${
                            isSelected
                              ? "border shadow-sm border-main bg-amber-100/30"
                              : "bg-white border-gray-200 hover:border-main/50"
                          }`}
                          onClick={() => {
                            setSelectedBaggage((prev) => {
                              const newSelectedBaggage = { ...prev };

                              if (!newSelectedBaggage[activePassengerTab]) {
                                newSelectedBaggage[activePassengerTab] = {};
                              }

                              detail.flightSegments.forEach((seg, segIdx) => {
                                const globalIdx = globalStartIdx + segIdx;
                                newSelectedBaggage[activePassengerTab][
                                  globalIdx
                                ] = {
                                  ...option,
                                  rph: seg.rph,
                                  DepartureDate: seg.departureDateTime,
                                  FlightNumber: seg.flightNumber,
                                  passengerIndex: activePassengerTab,
                                  TravelerRefNumberRPHList:
                                    passengers[activePassengerTab]?.refNumber,
                                  segmentCode: seg.segmentCode,
                                };
                              });

                              return newSelectedBaggage;
                            });
                          }}
                        >
                          <div className="flex justify-between items-center">
                            <span className="font-medium">
                              {option.baggageDescription}
                            </span>
                            <span className="font-semibold text-main">
                              {formatCurrency(
                                option.baggageCharge,
                                option.currencyCode
                              )}
                            </span>
                          </div>
                        </button>
                      );
                    })}
                  </div>
                </div>
              ))
            ) : (
              <p>Loading baggage options...</p>
            )}
            <button
              onClick={() => {
                setIsBaggageModalOpen(false);
                setActivePassengerTab(0);
              }}
              className="py-2 mt-4 w-full text-white rounded-lg bg-main"
            >
              Confirm Selection
            </button>
          </div>
        </div>
      )}
      {isMealModalOpen && (
        <div className="flex fixed inset-0 z-50 justify-center items-center p-4 bg-gray-50 bg-opacity-50 backdrop-blur-xl">
          <div className="bg-white rounded-xl max-w-7xl w-full max-h-[95vh] overflow-hidden text-black flex flex-col">
            <div className="sticky top-0 px-6 py-2 bg-white rounded-t-2xl border-b border-gray-200">
              <div className="flex justify-between items-center">
                <h3 className="text-xl font-semibold">Select Meals</h3>
                <button onClick={() => setIsMealModalOpen(false)}>
                  <Close className="w-6 h-6" />
                </button>
              </div>

              {/* Passenger Tabs for Meals */}
              <div className="mt-4 border-b border-gray-200">
                <nav className="flex -mb-px space-x-8">
                  {passengers?.map((passenger, passengerIdx) => (
                    <button
                      key={passengerIdx}
                      className={`py-2 px-4 border-b-2 text-base font-semibold ${
                        activePassengerTab === passengerIdx
                          ? "border-main-900 text-main"
                          : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                      }`}
                      onClick={() => setActivePassengerTab(passengerIdx)}
                    >
                      Passenger {passengerIdx + 1}
                    </button>
                  ))}
                </nav>
              </div>
            </div>

            <div className="flex flex-1 min-h-0">
              {/* Segment Selection Sidebar */}
              <div className="hidden overflow-y-auto w-64 bg-gray-50 border-r border-gray-200 md:block">
                <div className="p-4">
                  <h4 className="mb-3 text-sm font-medium tracking-wide text-gray-700 uppercase">
                    Segments
                  </h4>
                  <div className="space-y-2">
                    {mealDetails?.map((detail, segmentIdx) => (
                      <button
                        key={segmentIdx}
                        className={`w-full text-left p-3 rounded-lg transition-all ${
                          activeMealSegmentTab === segmentIdx
                            ? "bg-main text-white shadow-sm"
                            : "bg-white text-gray-700 hover:bg-gray-100 border border-gray-200"
                        }`}
                        onClick={() => setActiveMealSegmentTab(segmentIdx)}
                      >
                        <div className="text-sm font-medium tracking-wider">
                          {detail.segmentCode}
                        </div>
                      </button>
                    ))}
                  </div>
                </div>
              </div>

              {/* Main Content Area */}
              <div className="overflow-y-auto flex-1">
                {/* Mobile Segment Selection */}
                <div className="block px-4 py-3 bg-gray-50 border-b border-gray-200 md:hidden">
                  <h4 className="mb-2 text-sm font-medium tracking-wide text-gray-700 uppercase">
                    Select Segment
                  </h4>
                  <div className="flex overflow-x-auto gap-2 pb-2">
                    {mealDetails?.map((detail, segmentIdx) => (
                      <button
                        key={segmentIdx}
                        className={`flex-shrink-0 px-4 py-2 rounded-lg text-sm font-medium transition-all ${
                          activeMealSegmentTab === segmentIdx
                            ? "bg-main text-white shadow-sm"
                            : "bg-white text-gray-700 hover:bg-gray-100 border border-gray-200"
                        }`}
                        onClick={() => setActiveMealSegmentTab(segmentIdx)}
                      >
                        {detail.segmentCode}
                      </button>
                    ))}
                  </div>
                </div>

                <div className="px-6 py-2">
                  {mealDetails && activeMealSegmentTab !== null ? (
                    <div className="mb-2">
                      <div>
                        <h4 className="mb-4 text-lg font-medium">
                          Meals for Segment:{" "}
                          {mealDetails[activeMealSegmentTab]?.segmentCode}
                        </h4>
                        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
                          {mealDetails[activeMealSegmentTab]?.meals
                            ?.sort(
                              (a, b) =>
                                parseFloat(a.mealCharge) -
                                parseFloat(b.mealCharge)
                            )
                            .map((meal) => {
                              const isSelected =
                                selectedMeals[activePassengerTab]?.[
                                  activeMealSegmentTab
                                ]?.mealCode === meal.mealCode;

                              return (
                                <button
                                  key={meal.mealCode}
                                  className={`flex items-center border rounded-lg p-3 transition-all ${
                                    isSelected
                                      ? "bg-orange-50 border-orange-500"
                                      : "border-gray-200 hover:border-orange-300"
                                  }`}
                                  onClick={() => {
                                    // if (parseFloat(meal.mealCharge) > 0) {
                                    //   toast.error("Please choose free meal");
                                    //   return;
                                    // }
                                    setSelectedMeals((prev) => {
                                      const newSelectedMeals = { ...prev };

                                      if (
                                        !newSelectedMeals[activePassengerTab]
                                      ) {
                                        newSelectedMeals[activePassengerTab] =
                                          {};
                                      }

                                      newSelectedMeals[activePassengerTab][
                                        activeMealSegmentTab
                                      ] = {
                                        ...meal,
                                        rph: mealDetails[activeMealSegmentTab]
                                          .rph,
                                        DepartureDate:
                                          mealDetails[activeMealSegmentTab]
                                            .departureDateTime,
                                        FlightNumber:
                                          mealDetails[activeMealSegmentTab]
                                            .flightNumber,
                                        passengerIndex: activePassengerTab,
                                        TravelerRefNumberRPHList:
                                          passengers?.[activePassengerTab]
                                            ?.refNumber,
                                      };

                                      return newSelectedMeals;
                                    });
                                  }}
                                >
                                  {meal.mealImageLink && (
                                    <img
                                      src={meal.mealImageLink}
                                      alt={meal.mealName}
                                      className="object-cover mr-4 w-16 h-16 rounded-lg"
                                    />
                                  )}
                                  <div className="flex-1 text-left">
                                    <div className="text-base font-medium">
                                      {meal.mealName}
                                    </div>
                                    <div className="mb-1 text-xs text-gray-500">
                                      {meal.mealCategoryCode}
                                    </div>
                                    <div className="mb-1 text-sm text-gray-700">
                                      {meal.mealDescription}
                                    </div>
                                    <div className="font-semibold text-orange-600">
                                      {formatCurrency(
                                        parseFloat(meal.mealCharge),
                                        meal.currencyCode
                                      )}
                                    </div>
                                  </div>
                                </button>
                              );
                            })}
                        </div>
                      </div>
                    </div>
                  ) : (
                    <p>Loading meal options...</p>
                  )}
                </div>
              </div>
            </div>

            <div className="sticky bottom-0 px-6 py-4 bg-white rounded-b-2xl border-t border-gray-200">
              <button
                onClick={() => {
                  setIsMealModalOpen(false);
                  setActivePassengerTab(0);
                  setActiveMealSegmentTab(0);
                }}
                className="py-2 w-full text-white rounded-lg bg-main"
              >
                Confirm Selection
              </button>
            </div>
          </div>
        </div>
      )}
      {isSeatModalOpen && (
        <div className="flex fixed inset-0 z-50 justify-center items-center p-4 backdrop-blur-sm bg-black/70">
          <div className="bg-white rounded-xl max-w-6xl w-full max-h-[95vh] overflow-hidden shadow-xl">
            {/* Header */}
            <div className="px-8 py-2 text-black">
              <div className="flex justify-between items-center">
                <div>
                  <h3 className="text-2xl font-medium">Choose Your Seats</h3>
                  {/* Auto-Selected Seats Message */}
                  {autoSelectedSeats ? (
                    <div className="px-4 py-2 mt-1 bg-red-50 rounded-lg border border-red-200">
                      <div className="flex items-start">
                        <div className="ml-3">
                          <h3 className="text-sm font-medium text-red-500">
                            Seats Auto-Selected
                          </h3>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <p className="mt-1 text-sm text-gray-500 opacity-90">
                      Select your preferred seats for a comfortable journey
                    </p>
                  )}
                </div>
                <button
                  onClick={() => setIsSeatModalOpen(false)}
                  className="p-2 rounded-full transition-all duration-200 hover:bg-white/20"
                >
                  <Close className="w-6 h-6" />
                </button>
              </div>

              {/* Passenger Tabs for Seats */}
              <div className="mt-4 border-b border-gray-200">
                <nav className="flex -mb-px space-x-8">
                  {passengers?.map((passenger, passengerIdx) => (
                    <button
                      key={passengerIdx}
                      className={`py-2 px-4 border-b-2 font-medium text-sm ${
                        activeSeatTab === passengerIdx
                          ? "border-main-900 text-main"
                          : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                      }`}
                      onClick={() => setActiveSeatTab(passengerIdx)}
                    >
                      Passenger {passengerIdx + 1}
                    </button>
                  ))}
                </nav>
              </div>
            </div>

            {/* Content */}
            <div
              className="overflow-y-auto"
              style={{ maxHeight: "calc(90vh - 160px)" }}
            >
              {seatDetails && seatDetails.seatSelection ? (
                seatDetails.seatSelection.map((selection, idx) => (
                  <div key={idx} className="p-8">
                    {/* Flight Info */}
                    <div className="p-6 mb-8 bg-gradient-to-r to-blue-50 rounded-2xl border from-slate-50 border-slate-200">
                      <div className="flex justify-between items-center">
                        <div className="flex items-center space-x-4">
                          <div className="flex justify-center items-center w-12 h-12 rounded-2xl bg-main">
                            <span className="text-xl text-white">✈</span>
                          </div>
                          <div>
                            <h4 className="text-2xl font-semibold text-slate-900">
                              Flight {selection.flightNumber}
                            </h4>
                            <p className="text-black">
                              {selection.segmentCode}
                            </p>
                          </div>
                        </div>
                        <div className="text-right">
                          <div className="text-lg font-medium text-slate-900">
                            {customDate(selection.departureDateTime)}
                          </div>
                          <div className="text-black">
                            {customTime(selection.departureDateTime)} -{" "}
                            {customTime(selection.arrivalDateTime)}
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Seat Legend */}
                    <div className="px-4 py-2 mb-2 bg-white rounded-xl border border-slate-200">
                      <div className="flex flex-wrap gap-3 justify-center items-center text-sm">
                        <div className="flex items-center space-x-2">
                          <div className="w-6 h-6 bg-emerald-200 rounded-lg border-2 border-emerald-200"></div>
                          <span className="font-medium text-slate-700">
                            Available
                          </span>
                        </div>
                        <div className="flex items-center space-x-2">
                          <div className="w-6 h-6 bg-green-500 rounded-lg border-2 border-green-500"></div>
                          <span className="font-medium text-slate-700">
                            Free
                          </span>
                        </div>
                        <div className="flex items-center space-x-2">
                          <div className="w-6 h-6 bg-red-200 rounded-lg border-2 border-red-300"></div>
                          <span className="font-medium text-slate-700">
                            Inactive
                          </span>
                        </div>
                        <div className="flex items-center space-x-2">
                          <div className="w-6 h-6 bg-blue-500 rounded-lg border-2 border-blue-400"></div>
                          <span className="font-medium text-slate-700">
                            Selected
                          </span>
                        </div>
                        <div className="flex items-center space-x-2">
                          <div className="w-6 h-6 rounded-lg border-2 bg-slate-300 border-slate-300"></div>
                          <span className="font-medium text-slate-700">
                            Occupied
                          </span>
                        </div>
                      </div>
                    </div>

                    {/* Cabin Layout */}
                    <div className="space-y-3">
                      {selection.cabins.map((cabin, cabinIdx) => (
                        <div
                          key={cabinIdx}
                          className="overflow-hidden bg-white rounded-xl border shadow-sm border-slate-200"
                        >
                          {/* Cabin Header */}
                          <div className="px-4 py-2 text-black bg-amber-200">
                            <div className="flex justify-between items-center">
                              <h6 className="text-xl font-medium capitalize">
                                {cabin.class?.toLowerCase().replace("_", " ")}{" "}
                                Class
                              </h6>
                              <div className="text-black">
                                Rows {cabin.rows?.[0]?.rowNumber} -{" "}
                                {cabin.rows?.[cabin.rows.length - 1]?.rowNumber}
                              </div>
                            </div>
                          </div>

                          {/* Seat Map */}
                          <div className="p-4">
                            <div className="mx-auto max-w-lg">
                              {/* Aircraft Visual */}
                              <div className="relative">
                                <div className="mb-6 w-full h-6 bg-gradient-to-b rounded-t-full from-slate-300 to-slate-400"></div>

                                {/* Seat Grid */}
                                <div className="p-4 rounded-xl border bg-slate-50 border-slate-200">
                                  {/* Column Headers */}
                                  <div className="flex justify-center mb-4">
                                    <div className="grid grid-cols-6 gap-3 text-sm font-medium text-center text-black">
                                      {["A", "B", "C", "D", "E", "F"].map(
                                        (col) => (
                                          <div key={col} className="w-10">
                                            {col}
                                          </div>
                                        )
                                      )}
                                    </div>
                                  </div>

                                  {/* Seat Rows */}
                                  <div className="space-y-2">
                                    {RenderSeatMap({
                                      cabin,
                                      selection,
                                      idx,
                                      selectedSeats,
                                      setSelectedSeats,
                                      activeSeatTab,
                                      passengers,
                                    })}
                                  </div>
                                </div>

                                {/* <div className="mt-6 w-full h-4 bg-gradient-to-t rounded-b-full from-slate-300 to-slate-400"></div> */}
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>

                    {/* Selected Seats Summary */}
                    {Object.keys(selectedSeats).length > 0 && (
                      <div className="p-2 mt-3 bg-gradient-to-r from-emerald-50 to-blue-50 rounded-xl border border-emerald-200">
                        <div className="flex items-center mb-3">
                          <div className="flex justify-center items-center mr-4 w-6 h-6 bg-emerald-600 rounded-xl">
                            <span className="font-semibold text-white">✓</span>
                          </div>
                          <h5 className="text-xl font-semibold text-slate-900">
                            Your Selected Seats
                          </h5>
                        </div>
                        <div className="grid grid-cols-1 gap-2 md:grid-cols-2">
                          {Object.entries(selectedSeats).map(
                            ([passengerIndex, segments]) =>
                              Object.entries(segments).map(
                                ([segmentIndex, seat]) => (
                                  <div
                                    key={`${passengerIndex}-${segmentIndex}`}
                                    className="p-2 bg-white rounded-xl border border-emerald-200 shadow-sm"
                                  >
                                    <div className="flex justify-between items-center">
                                      <div>
                                        <div className="mb-1 text-sm font-medium text-black">
                                          Passenger{" "}
                                          {parseInt(passengerIndex) + 1}
                                        </div>
                                        <div className="text-2xl font-semibold text-main">
                                          {seat.rowNumber}
                                          {seat.seatNumber}
                                        </div>
                                      </div>
                                      <div className="text-right">
                                        <div className="mb-1 text-sm text-black">
                                          Price
                                        </div>
                                        <div className="text-xl font-semibold text-emerald-600">
                                          {formatCurrency(
                                            parseFloat(
                                              seat.seatCharacteristics
                                            ),
                                            seat.currencyCode
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )
                              )
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                ))
              ) : (
                <div className="flex flex-col justify-center items-center py-24">
                  <div className="relative mb-8">
                    <div className="w-20 h-20 rounded-full border-4 border-blue-200 animate-spin border-t-main"></div>
                    <div className="flex absolute inset-0 justify-center items-center">
                      <span className="text-3xl">✈</span>
                    </div>
                  </div>
                  <h4 className="mb-3 text-2xl font-medium text-slate-900">
                    Loading Seat Map
                  </h4>
                  <p className="max-w-md text-lg text-center text-black">
                    Preparing your aircraft seating layout...
                  </p>
                </div>
              )}
            </div>

            {/* Footer */}
            <div className="px-4 py-2 my-2 border-t backdrop-blur-sm bg-white/80 border-slate-200">
              <div className="flex justify-between items-center">
                <div className="text-black">
                  {Object.keys(selectedSeats).length > 0 ? (
                    <span className="text-lg font-medium text-emerald-600">
                      {Object.entries(selectedSeats)
                        .map(([, segments]) => Object.keys(segments).length)
                        .reduce((a, b) => a + b, 0)}{" "}
                      seat(s) selected
                    </span>
                  ) : (
                    <span className="text-lg">Select your preferred seats</span>
                  )}
                </div>
                <button
                  onClick={() => {
                    setIsSeatModalOpen(false);
                    setActiveSeatTab(0);
                    setAutoSelectedSeats(false);
                  }}
                  disabled={Object.keys(selectedSeats).length === 0}
                  className="px-4 py-2 text-lg font-medium text-white rounded-xl shadow-lg transition-all duration-300 transform bg-main disabled:opacity-50 disabled:cursor-not-allowed hover:shadow-xl hover:-translate-y-1"
                >
                  Confirm Selection
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Ancillaries;
